import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import { DataGrid } from '@mui/x-data-grid';

import { LocalizationContext } from '../../../../../AppContext';
import Toolbar from './AgreementstatusesTableToolbar';
import ColumnDefinition from './AgreementstatusesTableColumnDefinition';
import RowsMapper from './AgreementstatusesTableRowsMapper';
import localization from './AgreementstatusesTable.local';

export default function AgreementstatusesTable({
  agreements,
  agreementstatuses,
  // onRowClick,
  onAddClick,
  onCategoriesClick,
}) {
  const local = localization[useContext(LocalizationContext)];
  const [rows, setRows] = useState();
  const [columns, setColumns] = useState();

  useEffect(() => setColumns(ColumnDefinition(local)), []);
  useEffect(() => setRows(RowsMapper(local, agreements, agreementstatuses)), [agreements, agreementstatuses]);

  return (
    <Paper sx={{ height: '100%' }}>
      { columns && rows && (
        <DataGrid
          sx={{ height: '100%' }}
          rows={rows}
          columns={columns}
          // onRowClick={({ row }) => onRowClick(row.id)}
          components={{ Toolbar }}
          componentsProps={{ toolbar: { local, onAddClick, onCategoriesClick } }}
        />
      )}
    </Paper>
  );
}

AgreementstatusesTable.propTypes = {
  agreements: PropTypes.arrayOf(PropTypes.shape({})),
  agreementstatuses: PropTypes.arrayOf(PropTypes.shape({})),
  // onRowClick: PropTypes.func.isRequired,
  onAddClick: PropTypes.func.isRequired,
  onCategoriesClick: PropTypes.func.isRequired,
};

AgreementstatusesTable.defaultProps = {
  agreements: undefined,
  agreementstatuses: undefined,
};
